import React from "react";
import { useSelector } from "react-redux";
import "bootstrap";
import qs from "qs";

import LockedSite from "./LockedSite";
import { PARTY_NAME } from "./config";
import { leaveRoom } from "utils/useLocationUpdateEffect";
import VenueRouter from "components/venues/VenueRouter";

const ONE_HOUR_IN_SECONDS = 60 * 60;

function isAfterEvent(startUtcSeconds, durationMinutes) {
  const endUtcSeconds = startUtcSeconds + durationMinutes * 60;
  const lockSiteAfterUtcSeconds = endUtcSeconds + 12 * ONE_HOUR_IN_SECONDS;
  return new Date() / 1000 >= lockSiteAfterUtcSeconds;
}

export default function App(props) {
  const { config, user } = useSelector((state) => ({
    config:
      state.firestore.data.config && state.firestore.data.config[PARTY_NAME],
    user: state.user,
  }));

  window.onbeforeunload = () => {
    if (user) {
      leaveRoom(user);
    }
  };

  const search = qs.parse(props.location.search, { ignoreQueryPrefix: true });
  const unlock = search.unlock !== undefined;

  if (!config) {
    return "Loading...";
  }

  if (
    !unlock &&
    isAfterEvent(config.start_utc_seconds, config.duration_minutes)
  ) {
    return <LockedSite />;
  }

  return <VenueRouter />;
}
